import __request__ from "routing/request";
export function getClusterHealth(suppress_healthy = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.health/cluster", null, { "suppress_healthy": suppress_healthy }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
